import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MomentModule } from 'angular2-moment';

import { MomentComponent } from './moment.component';
import { MomentRoutingModule } from './moment.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MomentModule,
    MomentRoutingModule,
  ],
  exports: [
    MomentComponent
  ],
  declarations: [
    MomentComponent
  ],
})
export class MomentodModule { }
